var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEndCall = function SvgEndCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.076,13.789l-1.95,2.003c-0.259,0.269-0.687,0.278-0.956,0.019c-0.007-0.006-0.013-0.013-0.019-0.019L4.202,13.79 c-0.269-0.28-0.269-0.722,0-1.002l2.437-2.505c2.848-2.961,7.556-3.053,10.517-0.205c0.07,0.067,0.138,0.135,0.205,0.205 l2.437,2.505c0.27,0.276,0.27,0.725,0,1.002l-1.95,2.003c-0.259,0.269-0.687,0.277-0.956,0.018 c-0.006-0.006-0.012-0.012-0.018-0.018l-1.95-2.003c-0.269-0.28-0.269-0.722,0-1.002l0.487-0.5c-1.949-1.942-4.873-2.004-6.822,0 l0.487,0.5c0.27,0.277,0.27,0.725,0,1.002V13.789z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEndCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/end-call.8759d60c.svg";
export { ForwardRef as ReactComponent };